import { USE_TEMPLATE_ROUTE } from 'src/js/constants/common';

export default (path) => Boolean(path.split('/').find((item) => item === USE_TEMPLATE_ROUTE));
